module.exports = __webpack_public_path__ + "img/nikolaos-pitsitakis.60b239dc.jpg";